export default __webpack_public_path__ + "static/media/9.eee45759.jpeg";